import TournamentListListItem from './TournamentListListItem';

export default TournamentListListItem;
